function escapeCsv(value) {
  const str = value == null ? "" : String(value);
  return `"${str.replace(/"/g, '""')}"`;
}

export function downloadCsvFile({ headers = [], rows = [], filename }) {
  const lines = [];
  lines.push(headers.map(escapeCsv).join(","));
  rows.forEach(row => {
    lines.push((row || []).map(escapeCsv).join(","));
  });

  const csvContent = `${lines.join("\n")}\n`;
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const fileURL = window.URL.createObjectURL(blob);
  const fileLink = document.createElement("a");
  fileLink.href = fileURL;
  fileLink.setAttribute("download", filename);
  document.body.appendChild(fileLink);
  fileLink.click();
  document.body.removeChild(fileLink);
  window.URL.revokeObjectURL(fileURL);
}
